import { z } from "zod";

/**
 * Optional string schema for URL filter parameters.
 * Converts empty strings to undefined so they're removed from the URL.
 */
export const optionalFilterString = z
	.string()
	.optional()
	.transform((value) => (value === "" ? undefined : value));

/**
 * Optional string array schema for URL filter parameters.
 * Converts empty arrays to undefined so they're removed from the URL.
 */
export const optionalFilterStringArray = z
	.array(z.string())
	.optional()
	.transform((value) => (value?.length === 0 ? undefined : value));
